class ClientServices extends window.BAO.CustomElement() {
  constructor () {
    super()
    this.tier = ''
    this.openId = ''
  }

  connectedCallback () {
    super.connectedCallback()

    this.defaultImage = this.els['default-image']?.element || null
    this.serviceImages = this.els.image?.elements || []
    this.tierButtons = this.els['tier-button']?.elements || []
    this.services = this.els.service?.elements || []
    this.contents = this.els.content?.elements || []
    this.toggleButtons = this.els.button?.elements || []

    this.customerTier =
      this.dataset.customerTier ||
      this.querySelector('[data-customer-tier]')?.dataset.customerTier ||
      ''

    this.initTier()
    this.bindTierEvents()
    this.bindAccordionEvents()
    this.bindHoverEvents()
    this.initAccordionFromURL()
  }

  initTier () {
    this.tier = this.customerTier || 'tier_1'
    this.updateVisibleServices()
  }

  initAccordionFromURL () {
    const params = new URLSearchParams(window.location.search)
    const handle = params.get('accordion')
    if (!handle) return

    const toggle = this.querySelector(`[data-id="${handle}"]`)
    if (!toggle) return

    this.handleAccordionToggle(toggle)

    toggle.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }

  bindTierEvents () {
    this.tierButtons.forEach((btn) =>
      btn.addEventListener('click', () => this.handleTierChange(btn)),
    )
  }

  handleTierChange (btn) {
    this.tierButtons.forEach((b) => b.removeAttribute('aria-pressed'))
    btn.setAttribute('aria-pressed', 'true')
    this.tier = btn.dataset.tier
    this.openId = ''
    this.updateVisibleServices()
    this.showDefaultImage()
  }

  updateVisibleServices () {
    this.services.forEach((service) => {
      const available = (service.dataset.tiers || '').split(' ')
      service.setAttribute('aria-hidden', !available.includes(this.tier))
    })
  }

  bindAccordionEvents () {
    this.querySelectorAll('[data-toggle]').forEach((toggle) =>
      toggle.addEventListener('click', () =>
        this.handleAccordionToggle(toggle),
      ),
    )
  }

  handleAccordionToggle (toggle) {
    const id = toggle.dataset.toggle
    const content = this.querySelector(`#content-${id}`)
    const isOpen = this.openId === id

    this.contents.forEach((c) => c.setAttribute('aria-hidden', 'true'))
    this.toggleButtons.forEach((t) => t.removeAttribute('aria-pressed'))

    if (isOpen) {
      this.openId = ''
      this.showDefaultImage()
      return
    }

    this.openId = id
    toggle.setAttribute('aria-pressed', 'true')
    content?.removeAttribute('aria-hidden')
    this.showServiceImage(id)
  }

  bindHoverEvents () {
    this.services.forEach((service) => {
      const id = service.dataset.service
      service.addEventListener('mouseenter', () =>
        this.onServiceHoverEnter(id),
      )
      service.addEventListener('mouseleave', () => this.onServiceHoverLeave())
    })
  }

  onServiceHoverEnter (id) {
    if (!window.BAO.MediaBreakpoints.isMd || this.openId) return
    this.showServiceImage(id)
  }

  onServiceHoverLeave () {
    if (!window.BAO.MediaBreakpoints.isMd) return
    this.openId ? this.showServiceImage(this.openId) : this.showDefaultImage()
  }

  hideAllImages () {
    [...this.serviceImages, this.defaultImage]
      .filter(Boolean)
      .forEach((img) => img.setAttribute('aria-hidden', 'true'))
  }

  showDefaultImage () {
    this.showImage()
  }

  showServiceImage (id) {
    this.showImage(id)
  }

  showImage (id) {
    this.hideAllImages()
    const img = id
      ? this.querySelector(`[data-service-image="${id}"]`)
      : this.defaultImage
    img?.setAttribute('aria-hidden', 'false')
  }
}

if (!customElements.get('client-services')) {
  customElements.define('client-services', ClientServices)
}
